import { render, staticRenderFns } from "./forgot_password.vue?vue&type=template&id=69206e31&scoped=true&"
import script from "./forgot_password.vue?vue&type=script&lang=js&"
export * from "./forgot_password.vue?vue&type=script&lang=js&"
import style0 from "./forgot_password.vue?vue&type=style&index=0&id=69206e31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69206e31",
  null
  
)

export default component.exports